import analytics from '../utils/analytics';

const setupCalendy = () => {
  const isCalendlyEvent = (e) => e.data.event && e.data.event.indexOf('calendly') === 0;

  const watchedEvents = [
    'calendly.event_scheduled',
    'calendly.date_and_time_selected'
  ];

  window.addEventListener(
    'message',
    (e) => {
      if (isCalendlyEvent(e)) {
        const signUpType = window.calendyType || 'demo';
        if (watchedEvents.includes(e.data.event)) {
          const conversionType = `${e.data.event}.${signUpType}`;
          analytics.gtmClickEvent(conversionType, {});
        }
      }
    }
  );
};

export default setupCalendy;
